import React from "react";
import clsx from "clsx";
import { IconWarning } from "icons";

interface ITextarea {
  icon?: React.ReactNode;
  className?: string;
  containerClassName?: string;
  children: string;
  error: string;

  [key: string]: any;
}

const Textarea = ({ className, containerClassName, icon, error, ...etc }: ITextarea, ref: any) => {
  return (
    <>
      <div className={clsx("input-container flex flex-row items-center gap-2 p-3", "border border-white border-opacity-10 rounded-lg", containerClassName)}>
        <textarea ref={ref} className={clsx("input resize-none", className)} {...etc}></textarea>
        {icon}
      </div>
      {error && (
        <span className="flex text-orange text-h6 items-center gap-[5px]">
          <IconWarning className="h-[17px] w-[17px]" />
          {error}
        </span>
      )}
    </>
  );
};

export default React.forwardRef(Textarea);
